import {
  Component,
  computed,
  HostBinding,
  HostListener,
  input,
  Optional,
  output,
  SkipSelf,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BasicMenuComponent } from '../basic-menu.component';
import { TooltipComponent } from '../../tooltip/tooltip.component';
import { NgStyle } from '@angular/common';
import { isUrlOrImage } from '../../../utils';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  imports: [TooltipComponent, NgStyle],
})
export class MenuItemComponent {
  readonly label = input('');
  readonly icon = input<string | SafeHtml>();
  readonly iconSrc = input('');
  readonly iconName = input<string>();
  readonly reason = input('');
  readonly checked = input(false);
  readonly disabled = input(false);

  @HostBinding('class.disabled')
  get isDisabled() {
    return this.disabled();
  }

  readonly selected = output();

  readonly shape = computed(() => this.computeShape());
  readonly style = computed(() => this.computeStyle());
  readonly hasBgImage = computed(() => isUrlOrImage(this.icon()));

  constructor(
    private sanitizer: DomSanitizer,
    @SkipSelf() @Optional() private parentMenu: BasicMenuComponent | null,
  ) {}

  @HostListener('click', [])
  onClick() {
    if (this.isDisabled) {
      return;
    }
    if (this.parentMenu) {
      this.parentMenu.hideAll();
    }
    this.selected.emit();
  }

  private computeShape(): string | SafeHtml | undefined {
    if (this.hasBgImage()) {
      return ''; // not undefined, yet no content
    }
    const iconSrc = this.iconSrc();
    if (iconSrc) {
      // [innerHtml] filters out SVGs. To make it work it has to be sanitized explicitly
      return this.sanitizer.bypassSecurityTrustHtml(iconSrc);
    }
    return this.icon() ?? this.iconName();
  }

  private computeStyle(): { [k: string]: string } | undefined {
    const icon = this.icon();
    const hasBgImage = this.hasBgImage();
    if (typeof icon === 'string' && hasBgImage) {
      return { 'background-image': `url(${icon})` };
    }
    return;
  }
}
